export default {
  getMostrarErrors: state => state.mostrarErrors,
  getTemErrors: state => {
    let existeError = false;
    Object.values(state.abas).forEach(aba => {
      if (aba.temError) {
        existeError = true;
      }
    });
    return existeError;
  },
  getNomeDeAbasComErrors: state => {
    let array = [];
    Object.values(state.abas).forEach(aba => {
      if (aba.temError) {
        array.push(aba.nomeAba);
      }
    });
    return array;
  },
  getAbasComErrors: state => {
    let array = [];
    Object.values(state.abas).forEach(aba => {
      if (aba.temError) {
        array.push(aba);
      }
    });
    return array;
  },
  getMenssagemErrorModal: (_state, getters) => {
    const arrayDeNomes = getters.getNomeDeAbasComErrors;

    if (arrayDeNomes.length < 1) return;

    if (arrayDeNomes.length > 0) {
      return `
        Por favor corrija os erros na(s) aba(s) de ${arrayDeNomes.join(", ")} 
      `;
    } else {
      return "Nenhum error foi encontrado, o questionário está pronto para o salvamento.";
    }
  }
};
